import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";

export default function AddCertificate() {
  const [student_name, setStudentName] = useState("");
  const [course, setCourse] = useState("");
  const navigate = useNavigate();

  const save = async () => {
    if (!student_name || !course) {
      alert("Fill all fields");
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/api/add_certificate.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ student_name, course })
      });

      const text = await res.text(); // SAFE read
      console.log("RAW RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("❌ Server returned invalid JSON");
        return;
      }

      if (data.success) {
        alert("Certificate added ✅");
        navigate("/dashboard");
      } else {
        alert(data.error || "Failed to add certificate");
      }

    } catch (err) {
      console.error("FETCH ERROR:", err);
      alert("❌ Cannot reach backend. Check XAMPP & URL.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Add Certificate</h2>

      <input
        placeholder="Student Name"
        value={student_name}
        onChange={e => setStudentName(e.target.value)}
      />
      <br /><br />

      <input
        placeholder="Course"
        value={course}
        onChange={e => setCourse(e.target.value)}
      />
      <br /><br />

      <button onClick={save}>Save</button>
    </div>
  );
}
